// import { Storage } from '@/modules/plugins/storage'
import { Recommender } from '@/api'
// import Vue from 'vue'

const state = {
    recommender: null,
    recommendations: [],
    loading: false,
}
const mutations = {
    SET_RECOMMENDER(state, payload) {
        state.recommender = payload || null
    },
    SET_RECOMMENDATIONS(state, payload) {
        state.recommendations = payload || []
    },
    SET_LOADER(state, payload) {
        state.loading = payload || false
    },
}

const actions = {
    async load({ commit, getters }, payload) {
        if (!getters.enabled) return
        const recommender = new Recommender()
        try {
            const result = await recommender.fetch(payload)
            commit('SET_RECOMMENDER', result?.recommenderName)
            commit('SET_RECOMMENDATIONS', result?.recommendations)
        } catch (e) {
            commit('SET_RECOMMENDER')
            commit('SET_RECOMMENDATIONS')
        }
    },
    setLoader({ commit }, payload) {
        commit('SET_LOADER', payload)
    },
}

const getters = {
    enabled: (state, getters, rootState, rootGetters) =>
        rootGetters['site/config']?.recommender_enabled,
    recommender: (state) => state.recommender,
    recommendations: (state) => state.recommendations,
    loading: (state) => state.loading,
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}
